import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Measure } from '../../models/measure.model';
import { PagedMeasures } from '../../models/paged-measures.interface';
import { Api } from '../util/api';
import { SearchUtilsService } from '../util/search-utils.service';
import { LoadingService } from '../../../app/core/util/loading.service';

@Injectable()
export class MeasuresService {
  private endpoint: string = 'measures';

  constructor(private api: Api,
              private searchUtilsService: SearchUtilsService,
              private loadingService: LoadingService) {
  }

  public downloadMeasuresData(searchParams): Observable<any> {
    const options = {
      responseType: 'text'
    };
    const params = new HttpParams()
      .set('search', this.searchUtilsService.getSearchStringFromParams(searchParams));

    return this.api.get(`${this.endpoint}/download`, params, options).map(
      csvText => new Blob([csvText], { type: 'text/csv' })
    );
  }

  public searchMeasures(searchParams, page: number = 0, size: number = 10): Observable<PagedMeasures> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', 'date')
      .set('search', this.searchUtilsService.getSearchStringFromParams(searchParams));

    return this.api.get(`${this.endpoint}/search`, params);
  }

  public updateMeasure(measure: Measure): Observable<any> {
    Object.entries(measure).forEach(([key, value]) => {
      if (value === '') {
        measure[key] = null
      }
    });
    return this.api.put(`${this.endpoint}/${measure.id}`, measure).map(
      measure => this.api.handleSuccess(measure)
    );
  }

  public checkComputeMeasure() : Observable<boolean> {
    return this.api.get(this.endpoint + '/checkCompute', null)
  }

  public launchComputeMeasure() : void {
    this.loadingService.showLoader('Calcul des mesures en cours');
    this.api.put(this.endpoint+"/toCompute", null).subscribe(
      (response)=> {
        this.loadingService.hideLoader();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/measures.service.ts